import { ActionTypes } from "../constants/action-types";

export const setPlanDetail = (val) => {
  return {
    type: ActionTypes.SET_PLAN_DETAIL,
    payload: val,
  };
};
